// extracted by mini-css-extract-plugin
export default {"Feedback":"_4D3L3","wrap":"dj3UD","report":"jDyjQ","title":"_6DWOh","rating":"Ev06R","ratingText":"sItO4","text":"MlRRm","footer":"lNqWn","skeleton-progress":"KfKqh"};